import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=23290f29&"
import script from "./popup.vue?vue&type=script&lang=ts&"
export * from "./popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23290f29')) {
      api.createRecord('23290f29', component.options)
    } else {
      api.reload('23290f29', component.options)
    }
    module.hot.accept("./popup.vue?vue&type=template&id=23290f29&", function () {
      api.rerender('23290f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/popup.vue"
export default component.exports